import { Typography } from '@material-ui/core'
import { useAppSelector } from 'store/configureStore'
import { bomItemFileNameSelector } from '../store/selectors/bomItemFileNameSelector'

export const PartTypeFileName = ({ bomItemId }: { bomItemId: string }) => {
  const fileName = useAppSelector(bomItemFileNameSelector(bomItemId))

  return (
    <Typography variant="caption" color="textSecondary">
      {`${fileName}`}
    </Typography>
  )
}
